import { useQuery, gql, UseQueryState } from 'urql';

import { Team } from '../useCurrentTeam/useCurrentUserTeamsQuery';

const CurrentUserQuery = gql`
  query {
    currentUser {
      teams {
        id
        logoUrl
        defaultName
        name
        creatorId
        members {
          user {
            auth0UserId
          }
        }
        channel {
          name
        }
      }
      email
      auth0UserId
      givenName
      familyName
      profilePicture {
        id
        sourceUrl
        imageUrl
        thumbnailUrl
      }
    }
  }
`;

export interface CurrentUser {
  teams: Team[];
  email: string;
  auth0UserId: string;
  givenName: string;
  familyName: string;
  profilePicture: {
    id: string;
    sourceUrl: string;
    imageUrl: string;
    thumbnailUrl: string;
  };
}

export interface CurrentUserQueryResponse {
  currentUser: CurrentUser;
}

type CurrentUserQueryVariables = Record<string, never>;

export function useCurrentUserQuery(): UseQueryState<
  CurrentUserQueryResponse,
  CurrentUserQueryVariables
> {
  const [result] = useQuery<
    CurrentUserQueryResponse,
    CurrentUserQueryVariables
  >({
    query: CurrentUserQuery,
  });

  return result;
}
